var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.12C0 3.32783 0 2.43175 0.348779 1.74723C0.655574 1.14511 1.14511 0.655574 1.74723 0.348779C2.43175 0 3.32783 0 5.12 0H10.88C12.6722 0 13.5683 0 14.2528 0.348779C14.8549 0.655574 15.3444 1.14511 15.6512 1.74723C16 2.43175 16 3.32783 16 5.12V10.88C16 12.6722 16 13.5683 15.6512 14.2528C15.3444 14.8549 14.8549 15.3444 14.2528 15.6512C13.5683 16 12.6722 16 10.88 16H5.12C3.32783 16 2.43175 16 1.74723 15.6512C1.14511 15.3444 0.655574 14.8549 0.348779 14.2528C0 13.5683 0 12.6722 0 10.88V5.12ZM12.5657 6.16567C12.8781 5.85327 12.8781 5.34672 12.5657 5.03432C12.2533 4.72189 11.7467 4.72189 11.4343 5.03432L6.39999 10.0686L4.56567 8.23432C4.25327 7.92189 3.74672 7.92189 3.43432 8.23432C3.12189 8.54672 3.12189 9.05327 3.43432 9.36567L5.55146 11.4828C6.02009 11.9515 6.7799 11.9515 7.24853 11.4828L12.5657 6.16567Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.15496045.svg";
export { ForwardRef as ReactComponent };